import React, { useEffect, useState } from 'react';

const FallingFlowers = () => {
  const [flowers, setFlowers] = useState([]);

  useEffect(() => {
    // Tạo 30 cánh hoa với vị trí và tốc độ ngẫu nhiên
    const newFlowers = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      left: Math.random() * 100, // vị trí ngang (%)
      animationDuration: 8 + Math.random() * 10, // 8-18s
      animationDelay: Math.random() * 5, // delay 0-5s
      size: 20 + Math.random() * 15, // 20-35px
      opacity: 0.4 + Math.random() * 0.4, // 0.4-0.8
      flower: ['🌸', '💮', '🌷', '🌺'][Math.floor(Math.random() * 4)],
      swingDuration: 2 + Math.random() * 2, // 2-4s cho hiệu ứng lắc
    }));
    setFlowers(newFlowers);
  }, []);

  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
      {flowers.map((flower) => (
        <div
          key={flower.id}
          className="absolute animate-fall"
          style={{
            left: `${flower.left}%`,
            fontSize: `${flower.size}px`,
            opacity: flower.opacity,
            animationDuration: `${flower.animationDuration}s`,
            animationDelay: `${flower.animationDelay}s`,
            '--swing-duration': `${flower.swingDuration}s`,
          }}
        >
          <div className="animate-swing">
            {flower.flower}
          </div>
        </div>
      ))}
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes fall {
          0% {
            transform: translateY(-100px) rotate(0deg);
          }
          100% {
            transform: translateY(calc(100vh + 100px)) rotate(360deg);
          }
        }
        
        @keyframes swing {
          0%, 100% {
            transform: translateX(-15px);
          }
          50% {
            transform: translateX(15px);
          }
        }
        
        .animate-fall {
          animation: fall linear infinite;
        }
        
        .animate-swing {
          animation: swing ease-in-out infinite;
          animation-duration: var(--swing-duration);
        }
      `}} />
    </div>
  );
};

export default FallingFlowers;
